<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('stageId')" class="col-sm-4 col-form-label">Stage</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('stageId')" v-model="stageId" :options="optionsStages"
                         text-field="text" value-field="value">
          </b-form-select>
        </div>
      </div>
      <number-input-group v-model="group" label="Group"></number-input-group>
      <table class="table table-bordered table-responsive table-hover table-sm" v-if="rounds && rounds.length">
        <thead>
        <tr>
          <th>Round</th>
          <th>Templates</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in rounds">
          <td>{{ row.name }}</td>
          <td>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateLowerThirds(row, 'lead')"
                    title="Lower Thirds Lead">LTL
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateLowerThirds(row, 'speed')"
                    title="Lower Thirds Speed">LTS
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateStartingList(row)"
                    title="Starting List">SL
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateLeadIntermediate(row)"
                    title="Lead Intermediate">LI
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateRankingListProvisional(row)"
                    title="Ranking List Provisional">RP
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateRankingListResults(row)"
                    title="Ranking List Results">RR
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateVictoryCeremonyAthlete(row)"
                    title="Victory Ceremony Athlete">VCA
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="openCreateVictoryCeremonyGroup(row)"
                    title="Victory Ceremony Group">VCG
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('baseUrl')" class="col-sm-4 col-form-label">Results-API</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('baseUrl')" v-model.lazy="baseUrl">
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-12">
          <button type="button" class="btn btn-block btn-primary" @click="fetchCompetitions">Fetch</button>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('competitionId')" class="col-sm-4 col-form-label">Competition</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('competitionId')" v-model="competitionId" :options="optionsCompetitions"
                         text-field="text" value-field="value">
          </b-form-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '@/lib'
  import { templateMixin } from '@/mixins'
  import { mapTemplateOptions } from '../../utils/index'
  import UiaaApi from '../../api/UiaaApi'
  import AppService from '../../api/AppService'
  import * as mutation from '../../store/mutation-types'

  export default {
    name: 'uiaa',
    mixins: [templateMixin],
    data () {
      return {
        errorMessage: null,
        competitions: [],
        stages: [],
        rounds: [],
        group: 0
      }
    },
    created () {
      this.uiaaApi = new UiaaApi()
      this.appService = new AppService(this.$store, this.$keycloak)
    },
    mounted () {
      this.fetchCompetitions()
        .then(() => {
          if (this.competitionId) {
            return this.fetchStages(this.competitionId)
              .then(() => {
                if (this.stageId) {
                  this.fetchRounds(this.competitionId, this.stageId)
                }
              })
          }
        })
    },
    computed: {
      ...mapTemplateOptions({'baseUrl': {default: 'https://results.theuiaa.org'}}),
      ...mapTemplateOptions(['competitionId', 'stageId']),
      optionsCompetitions () {
        return [{text: '', value: null}].concat(this.competitions.map(each => {
          return {
            text: each.name + ' / ' + each.date + ' / ' + each.location,
            value: each.id
          }
        }))
      },
      optionsStages () {
        return [{text: '', value: null}].concat(this.stages.map(each => {
          return {
            text: each.name,
            value: each.id
          }
        }))
      }
    },
    watch: {
      competitionId: function (val) {
        console.debug('[uiaa] watched competitionId ' + val)
        this.fetchStages(val)
      },
      stageId: function (val) {
        console.debug('[uiaa] watched stageId ' + val)
        this.fetchRounds(this.competitionId, val)
      }
    },
    methods: {
      openCreateLowerThirds (round, type) {
        const componentTypes = {
          'lead': 'uiaa-lower-third-lead',
          'speed': 'uiaa-lower-third-speed'
        }
        const stage = this.getStage()
        const url = this.api().getStartingListUrl(round.competitionId, round.stageId, round.id, this.group)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.name + ' ' + round.name + ' Starting List',
          url
        }, 'uiaa-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Lower Thirds ' + stage.name + ' ' + round.name,
          componentType: componentTypes[type],
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {},
          columnMap: {}
        })
      },
      openCreateStartingList (round) {
        const stage = this.getStage()
        const url = this.api().getStartingListUrl(round.competitionId, round.stageId, round.id, this.group)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.name + ' ' + round.name + ' Starting List',
          url
        }, 'uiaa-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Starting List ' + stage.name + ' ' + round.name,
          componentType: 'starting-list',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: ('STARTING LIST ' + stage.name + ' ' + round.name).toUpperCase(),
            subtitle: (this.getCompetition() || {}).destination
          },
          columnMap: {
            'bibNumber': 'BIB',
            'lastName': 'LAST NAME',
            'firstName': 'FIRST NAME',
            'country': 'COUNTRY'
          }
        })
      },
      openCreateLeadIntermediate (round) {
        const stage = this.getStage()
        const url = this.api().getStartingListUrl(round.competitionId, round.stageId, round.id, this.group)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.name + ' ' + round.name + ' Intermediates',
          url,
          columns: ['TIME']
        }, 'uiaa-dataset-window')
        window.setTimeout(function () {
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId,
            fileName: this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group),
            emit: true
          })
        }.bind(this), 1000)
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Intermediates ' + stage.name + ' ' + round.name,
          componentType: 'uiaa-lead-intermediate-standings',
          templateData: {datasetId},
          templateOptions: {},
          columnMap: {
            'bibNumber': 'BIB',
            'lastName': 'LAST NAME',
            'firstName': 'FIRST NAME',
            'country': 'COUNTRY',
            'score': 'Route 1',
            'endTime': 'ENDTIME'
          }
        })
      },
      openCreateRankingListProvisional (round) {
        this.openCreateRankingList(round, true)
      },
      openCreateRankingListResults (round) {
        this.openCreateRankingList(round, false)
      },
      openCreateRankingList (round, provisional) {
        const stage = this.getStage()
        const url = this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.name + ' ' + round.name + ' Ranking List',
          url
        }, 'uiaa-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Ranking List ' + (provisional ? 'w/o' : 'w/') + ' Results ' + stage.name + ' ' + round.name,
          componentType: 'ranking-list',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: ('PROVISIONAL RANKINGS ' + stage.name + ' ' + round.name).toUpperCase(),
            subtitle: (this.getCompetition() || {}).destination
          },
          columnMap: {
            'bibNumber': 'BIB',
            'lastName': 'LAST NAME',
            'firstName': 'FIRST NAME',
            'country': 'COUNTRY',
            'rank': 'RANK',
            'score': 'Route 1',
            'qualified': 'Qualified'
          },
          overlays: [
            provisional ? 'uiaa/ranking-list-without-results.vue' : 'uiaa/ranking-list-with-results.vue'
          ]
        })
      },
      openCreateVictoryCeremonyAthlete (round) {
        const stage = this.getStage()
        const url = this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.name + ' ' + round.name + ' Ranking List',
          url
        }, 'uiaa-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Victory Ceremony Athlete ' + stage.name + ' ' + round.name,
          componentType: 'uiaa-victory-ceremony-athlete',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: (stage.name).toUpperCase()
          }
        })
      },
      openCreateVictoryCeremonyGroup (round) {
        const stage = this.getStage()
        const url = this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group)
        const datasetId = this.appService.openCreateDataset({
          datasetId: uuid(),
          name: stage.name + ' ' + round.name + ' Ranking List',
          url
        }, 'uiaa-dataset-window')
        this.appService.openCreateTemplate({
          templateId: uuid(),
          name: 'Victory Ceremony Group ' + stage.name + ' ' + round.name,
          componentType: 'uiaa-victory-ceremony-group',
          templateData: {datasetId},
          templateOptions: {},
          overlayData: {
            title: (stage.name).toUpperCase()
          }
        })
      },
      fetchCompetitions () {
        this.errorMessage = null
        return this.api().fetchCompetitions()
          .then(competitions => {
            console.log('[uiaa] fetched ' + competitions.length + ' competitions')
            this.competitions = competitions
          })
          .catch(err => {
            console.error('[uiaa] error fetching competitions', err)
            this.errorMessage = err.message
          })
      },
      fetchStages (competitionId) {
        this.errorMessage = null
        console.log('[uiaa] fetching stages for competition ' + competitionId)
        return this.api().fetchStages(competitionId)
          .then(stages => {
            console.log('[uiaa] fetched ' + stages.length + ' stages')
            this.stages = stages
          })
          .catch(err => {
            console.error('[uiaa] error fetching stages', err)
            this.errorMessage = err.message
          })
      },
      fetchRounds (competitionId, stageId) {
        this.errorMessage = null
        console.log(`[uiaa] fetching rounds for competition ${competitionId}, stage ${stageId}`)
        this.api().fetchRounds(competitionId, stageId)
          .then(rounds => {
            console.log('[uiaa] fetched ' + rounds.length + ' rounds')
            this.rounds = rounds
          })
          .catch(err => {
            console.error('[uiaa] error fetching rounds', err)
            this.errorMessage = err.message
          })
      },
      getCompetition () {
        return this.competitions.find(p => p.id === this.competitionId)
      },
      getStage () {
        return this.stages.find(p => p.id === this.stageId)
      },
      api () {
        return this.uiaaApi.setBaseUrl(this.baseUrl)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/templates/uiaa-results-center.vue